"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageContainerStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _constants = require("../constants");
var _imageUploaderTheme = require("./imageUploaderTheme");
const ImageContainerStyled = (0, _styled.default)("div")`
    height: 100%;
    position: relative;
    border-radius: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _imageUploaderTheme.imageUploaderTheme.border.radius(themeMode);
}};
    ${props => props.backgroundColorShow ? `background-color: transparent;` : ""}
    .${_constants.LOGO_CLASS} & {
        border-radius: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _imageUploaderTheme.imageUploaderTheme.border.logoRadius(themeMode);
}};
    }
`;
exports.ImageContainerStyled = ImageContainerStyled;
//# sourceMappingURL=ImageContainerStyled.js.map